export default "__VITE_ASSET__Cg19aILO__"